import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const AICopilot = React.lazy(
  () => import("../../../containers/pages/ai-copilot"),
);

const AICopilotPages = ({ match }) => (
  <div className="dashboard-wrapper">
    <Suspense fallback={<div className="loading" />}>
      <Switch>
        <Route path={`${match.url}/`} render={(props) => <AICopilot {...props} />} />
        <Redirect to="/error" />
      </Switch>
    </Suspense>
  </div>
);

export default AICopilotPages;
